
export function waitForMs(ms: number): Promise<NodeJS.Timeout> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function waitForSeconds(seconds: number): Promise<NodeJS.Timeout> {
  return waitForMs(seconds * 1000);
}
